export default __webpack_public_path__ + "static/media/uploader-ascensiaContour-problem-1.8bb42773.png";